import { jsxs as p, jsx as r } from "react/jsx-runtime";
import { s as t, b as a, c as x, Q as i } from "./themes-5f0b3c3d.mjs";
import { z as u } from "./zIndices-d07533f3.mjs";
import "react";
import { Button as g } from "./button.js";
import { CloseButton as h } from "./closeButton.js";
import { u as n } from "./index-6a632112.mjs";
import "./lineHeights-72d3110c.mjs";
import "./textStyles-42cab346.mjs";
import "./fontWeights-a25f8f91.mjs";
import "./accessibility.js";
import "./cancelClose-87fdf326.mjs";
import "./types-b577bf77.mjs";
import "./iconButton.js";
const $ = n.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${t["6x"]};
  max-width: ${({ size: o }) => {
  switch (o) {
    case "extra large":
      return "1440px";
    case "large":
      return "1224px";
    case "medium":
      return "900px";
    case "small":
      return "500px";
  }
}};
  gap: ${t["8x"]};
  border-top: ${a["1x"]} solid ${x.brandTwilight[400]};
  background: ${(o) => o.theme.components.cookieBanner.cookieBannerBackground};
  color: ${(o) => o.theme.components.cookieBanner.cookieBannerColor};
  position: fixed;
  bottom: 0;
  box-shadow: 0px ${a["2x"]} ${a["8x"]} 0px
    rgba(0, 0, 0, 0.1);
  z-index: ${u.banner};
  right: 0;

  @media ${i.tabletAndUp} {
    right: unset;
    max-width: auto;
    flex-direction: ${(o) => o.size === "small" ? "column" : "row"};
  }
`, b = n.div`
  display: flex;
  align-items: center;
  gap: ${t["4x"]};
  flex-direction: column;
  width: 100%;

  @media ${i.tabletAndUp} {
    width: ${(o) => o.size === "small" ? "100%" : "auto"};
    flex-direction: row;
  }
`, f = n.div`
  position: absolute;
  top: ${t["6x"]};
  right: ${t["6x"]};
  padding: 5px;

  @media ${i.tabletAndUp} {
    position: unset;
    ${({ size: o }) => o === "small" && `
     position: absolute;
    
  `}
  }
`, k = n.div`
  margin-right: 54px;

  @media ${i.tabletAndUp} {
    margin-right: unset;
    ${({ size: o }) => o === "small" && `
     margin-right: 54px;
  `}
  }
`, R = ({
  children: o,
  showClose: m = !0,
  size: e = "medium",
  onClose: s,
  buttonAction: l,
  buttonLable: d = "Cookie Settings",
  ...c
}) => /* @__PURE__ */ p($, { size: e, ...c, children: [
  /* @__PURE__ */ r(k, { size: e, children: o }),
  /* @__PURE__ */ p(b, { size: e, children: [
    /* @__PURE__ */ r(g, { style: { width: "100%" }, onClick: l, children: d }),
    m && /* @__PURE__ */ r(f, { size: e, children: /* @__PURE__ */ r(h, { onClick: s }) })
  ] })
] });
export {
  R as CookieBanner
};
